import React from "react"
import Dropzone, { DropzoneState } from "react-dropzone"
import { DropzoneArea } from "dash-styled"

interface Props {
    onFileReceived: (fileContents: string) => void
}

const render = ({
    getRootProps,
    getInputProps,
    isDragAccept
}: DropzoneState): JSX.Element => {
    return (
        <div {...getRootProps()}>
            <DropzoneArea
                inputProps={getInputProps()}
                acceptDrop={isDragAccept}
                dragText="Drag your file here"
                dropText="Drop your file here"
                changeText="Change File"
            />
        </div>
    )
}

const onDrop = (
    acceptedFiles: any,
    resolve: (content: string | null, error?: string) => void
) => {
    acceptedFiles.forEach((file: any) => {
        const reader = new FileReader()
        reader.onload = () => {
            if (reader.result && typeof reader.result === "string")
                resolve(reader.result)
        }
        reader.onabort = () => resolve(null, "aborted")
        reader.onerror = () => resolve(null, "error")
        reader.readAsText(file, "utf-8")
    })
}

export const AddFiles = ({ onFileReceived }: Props) => {
    const handleDrop = (files: any) => {
        onDrop(files, (content, error) => {
            if (error || !content) {
                console.log(error || "No content")
                return
            }

            onFileReceived(content)
        })
    }

    return (
        <Dropzone onDrop={handleDrop} accept="application/json">
            {render}
        </Dropzone>
    )
}
